<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let record;

    const addToCartHandler = (record) => {
        dispatch('add', record);
    };

    const removeFromCartHandler = (record) => {
        dispatch('remove', record);
    };
</script>

<style>

</style>

<span class="order-buttons" style="margin-left: 0.5em;">
    {#if ( (record?._orderedItems || 0) > 0)}
        <button class="add-button pointer" on:click|stopPropagation={removeFromCartHandler(record)}>-</button>
        <span class="counter">{record?._orderedItems}</span>
    {/if}
    <button class="add-button pointer" on:click|stopPropagation={addToCartHandler(record)}>+</button>
</span>
